module.exports = __webpack_public_path__ + "img/sns_facebook.03037f3.svg";